import { useRef, useState } from 'react';

import { NavLink } from 'react-router-dom';

import {
  Avatar,
  Box,
  Button,
  Divider,
  Hidden,
  lighten,
  List,
  ListItem,
  ListItemText,
  Popover,
  Typography
} from '@mui/material';

import InboxTwoToneIcon from '@mui/icons-material/InboxTwoTone';
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import AccountBoxTwoToneIcon from '@mui/icons-material/AccountBoxTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';
import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone';
import Person2OutlinedIcon from '@mui/icons-material/Person2Outlined';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';
import axios from 'axios';
import { useSnackbar } from 'src/components/snackbar/useSnackbar';
import LockResetIcon from '@mui/icons-material/LockReset';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import { post } from 'src/services/httpClient.service';
import GpsFixedIcon from '@mui/icons-material/GpsFixed';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};
`
);

const MenuUserBox = styled(Box)(
  ({ theme }) => `
        background: ${theme.colors.alpha.black[5]};
        padding: ${theme.spacing(2)};
`
);

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
);

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: ${theme.palette.secondary.main};
        display: block;
`
);

const UserBoxDescription = styled(Typography)(
  ({ theme }) => `
        color: ${lighten(theme.palette.secondary.main, 0.5)}
`
);

function HeaderUserbox() {
  const username1 = localStorage.getItem('user')
  const { showSnackbar } = useSnackbar();

  const [userDetails, setusername] = useState<any>(JSON.parse(username1))


  const APIURL = process.env.REACT_APP_BASE_API_URL;

  const accountType = localStorage.getItem('accountType');
 
  

  const user = {
    name: 'Account Admin',
    avatar: '/static/images/logo2.png',
    jobtitle: 'Admin'
  };

  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const logout = async () => {
    console.log('tokenuserid', userDetails.userId)
    try {

      const tokenreponse = await post(`${APIURL}/api/operators/logout/${userDetails.userId}`)

      localStorage.removeItem('user')
      localStorage.removeItem('token')
      localStorage.removeItem('login')
      localStorage.removeItem('registrationName');
      localStorage.removeItem('companyName');
      localStorage.removeItem('companyShortName');
      localStorage.clear();
      window.location.href = "/";
      showSnackbar(tokenreponse.data.message, 'success')
    } catch (error) {
      showSnackbar(error, 'error')
    }



  }

  return (
    <>

      <UserBoxButton color="secondary" ref={ref} onClick={handleOpen}>
        {<Person2OutlinedIcon />}
        <Hidden mdDown>
          <UserBoxText>
            <UserBoxLabel variant="body1">
              {userDetails?.userName?.replace(' null', '')}</UserBoxLabel>
            {/* <UserBoxDescription variant="body2">
              {user.jobtitle}
            </UserBoxDescription> */}
          </UserBoxText>
        </Hidden>
        <Hidden smDown>
          <ExpandMoreTwoToneIcon sx={{ ml: 1 }} />
        </Hidden>
      </UserBoxButton>
      <Popover
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
      >
        <MenuUserBox sx={{ minWidth: 210 }} display="flex">
          <Avatar variant="rounded" alt={userDetails?.userName} src={user.avatar} />
          <UserBoxText>
            <UserBoxLabel variant="body1">{userDetails?.userName?.replace(' null', '')}</UserBoxLabel>
            <UserBoxDescription variant="body2">
              {userDetails?.userEmail}
            </UserBoxDescription>
          </UserBoxText>
        </MenuUserBox>

        {/* profile */}
        <Divider sx={{ mb: 0 }} />
        <List sx={{ p: 1 }} component="nav">
          <ListItem button to="/management/profile/details" component={NavLink} onClick={handleClose}>
            <AccountBoxTwoToneIcon fontSize="small" />
            <ListItemText primary="My Profile" />
          </ListItem>
        </List>

        {/* Area Price List */}
       
          <>
            <Divider sx={{ mb: 0 }} />
            <List sx={{ p: 1 }} component="nav">
              <ListItem button to="/areapricelist/AreaPriceList" component={NavLink} onClick={handleClose}>
                <LocalOfferIcon fontSize="small" />
                <ListItemText primary="Area Price List" />
              </ListItem>
            </List>
          </>
        

         {/* OTA List */}
         {accountType === 'OWNER' && (
          <>
            <Divider sx={{ mb: 0 }} />
            <List sx={{ p: 1 }} component="nav">
              <ListItem button to="/OTA/OTASCREEN" component={NavLink} onClick={handleClose}>
                <LiveTvIcon fontSize="small" />
                <ListItemText primary="OTA List" />
              </ListItem>
            </List>
          </>
        )}


        {/* Version List */}
{accountType === 'OWNER' && (
  <>
    <Divider sx={{ mb: 0 }} />
    <List sx={{ p: 1 }} component="nav">
      <ListItem
        button
        to="/Versions/VersionList"
        component={NavLink}
        onClick={handleClose}
      >
        <NewReleasesIcon fontSize="small" />
        <ListItemText primary="Versions" />
      </ListItem>
    </List>
  </>
)}

        {/* Reset Password */}
        <Divider sx={{ mb: 0 }} />
        <List sx={{ p: 1 }} component="nav">
          <ListItem button to="/Resetpassword/Resetpassword" component={NavLink} onClick={handleClose}>
            <LockResetIcon fontSize="small" />
            <ListItemText primary="Reset Password" />
          </ListItem>


        </List>
        {/* Application config */}
        {accountType === 'OWNER' && (
          <>
            <Divider />
            <List sx={{ p: 1 }} component="nav">
              <ListItem
                button
                to="/ApplicationConfig/ApplicationConfig"
                component={NavLink}
                onClick={handleClose}
              >
                <SettingsTwoToneIcon fontSize="small" />
                <ListItemText primary="Application Config" />
              </ListItem>
            </List></>
        )}

        {(accountType === 'OWNER' || accountType === 'DISTRIBUTOR')  && (
          <>
            <Divider />
            <List sx={{ p: 1 }} component="nav">
              <ListItem
                button
                to="/ottpaymentgateway/paymentgateway"
                component={NavLink}
                onClick={handleClose}
              >
                <PointOfSaleIcon fontSize="small" />
                <ListItemText primary="Paymentgateway List" />
              </ListItem>
            </List></>
        )}

        <Divider />

        {(accountType === 'OWNER')  && (
          <>
            <Divider />
            <List sx={{ p: 1 }} component="nav">
              <ListItem
                button
                to="/FranchiseLocations/FranchiseLocations"
                component={NavLink}
                onClick={handleClose}
              >
                <GpsFixedIcon fontSize="small" />
                <ListItemText primary="Locations" />
              </ListItem>
            </List></>
        )}

        {(accountType === 'OWNER')  && (
          <>
            <Divider />
            <List sx={{ p: 1 }} component="nav">
              <ListItem
                button
                to="/Thirdparty/ThirdPartyApps"
                component={NavLink}
                onClick={handleClose}
              >
                <AppSettingsAltIcon fontSize="small" />
                <ListItemText primary="Third-Party Apps" />
              </ListItem>
            </List></>
        )}

        <Divider />
        <Box sx={{ m: 1 }}>
          <Button color="primary" fullWidth onClick={logout}>
            <LockOpenTwoToneIcon sx={{ mr: 1 }} />
            Signout
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderUserbox;
